import React from "react";

export type StepIndicatorMode = "client" | "global" | "adhoc";

interface Step {
  num: number;
  displayNum: number;
  label: string;
}

const CLIENT_STEPS: Step[] = [
  { num: 1, displayNum: 1, label: "Define meal parameters" },
  { num: 2, displayNum: 2, label: "How do you want to start?" },
  { num: 3, displayNum: 3, label: "Pick a template" },
];

const GLOBAL_STEPS: Step[] = [
  { num: 1, displayNum: 1, label: "Define meal parameters" },
  { num: 3, displayNum: 2, label: "Meal timing & schedule" },
];

const getStepsForMode = (mode: StepIndicatorMode): Step[] => {
  if (mode === "global") return GLOBAL_STEPS;
  return CLIENT_STEPS;
};

interface MealPlanStepIndicatorProps {
  currentStep: number;
  mode?: StepIndicatorMode;
}

const MealPlanStepIndicator: React.FC<MealPlanStepIndicatorProps> = ({
  currentStep,
  mode = "client",
}) => {
  const steps = getStepsForMode(mode);

  return (
    <div className="flex items-center w-full">
      {steps.map((step, index) => {
        const isDone = currentStep > step.num;
        const isActive = currentStep === step.num;
        return (
          <React.Fragment key={step.num}>
            <div className="flex items-center gap-2 flex-shrink-0">
              {isDone ? (
                <div className="w-4 h-4 rounded-full bg-[#0DB5B5] flex items-center justify-center flex-shrink-0">
                  <svg
                    className="w-2.5 h-2.5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2.5}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              ) : (
                <div
                  className={`w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-semibold
                    ${
                      isActive
                        ? "bg-[#1F1F1F] text-white"
                        : "border border-[#C4C4C4] text-[#8E8E93] bg-white"
                    }`}
                >
                  {step.displayNum}
                </div>
              )}
              <span
                className={`text-[12px] 3xl:text-[14px] font-inter whitespace-nowrap
                  ${
                    isDone
                      ? "text-[#0DB5B5] font-medium"
                      : isActive
                        ? "text-[#1F1F1F] font-semibold"
                        : "text-[#8E8E93] font-normal"
                  }`}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className="flex-1 mx-4 border-t border-dashed"
                style={{
                  borderColor: currentStep > step.num ? "#0DB5B5" : "#D1D5DB",
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default MealPlanStepIndicator;
